;(function ($, window, document) {

  function onDOMContentLoaded() {
    var productMenuToggle = '.js-product-list-overlay-toggle',
        productMenu = '#js-product-list-overlay';

    // Toggle overlay
    $(productMenuToggle).on('click', function (event) {
      var wasOpen = $(productMenu).hasClass('open')
      event.preventDefault();
      $(productMenu).toggleClass('open');
      $(event.currentTarget).toggleClass('open');
      $(document.body).toggleClass('no-scroll');
      if (wasOpen) {
        $(productMenuToggle).focus()
      } else {
        setTimeout(function () {
          $(productMenu)
            .find('h2.product-list-overlay__title')
            .attr('tabindex', -1)
            .focus()
        }, 0)
      }
    })

    // Close overlay if it's open and ESC key is pressed
    $(document).keyup(function (event) {
      if (event.keyCode === 27) {
        if ($(productMenu).hasClass('open')) {
          $(productMenu).removeClass('open');
          $(document.body).removeClass('open');
          $(productMenuToggle).focus()
        }
      }
    });
  }
  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }

})(jQuery, window, document);
